// extracted by mini-css-extract-plugin
export default {"videoEmbed":"E5DWdy","player":"FMKsVM","thumbnail":"ZkVtZC","overlay":"QdXIPy","button":"ul_Osp","arrow":"BbU38r","icon":"qCU9oG"};